import axios from "@/config/http.js"
import api from  "@/config/api.js"
import tools from  "@/public/tools.js"
export default {
	getCommonData({commit}){
		return axios.get(api.quoteCommon).then((res)=>{
			//處理數據 
			/*
			1，刪除注釋信息
			2，/<\/?.+?\/?>/g
			*/
			try{
				// data = data.replace(/<!--?.+-->/g,"").replace(/\\/g,"/");
				// let res = JSON.parse(data);
				if(res.code==200){
					commit("setPublicData",res.data);
					return res.data;
				}
			}catch(e){
				console.log(e)
			}			
		})
	},
	getLuanguge({commit},arg){
		//獲取語言包		
		let prefix  = "languange_"+ arg.code + "_";
		let key = prefix + arg.key;			
		let lanobj = tools.getSlocal(key);
		if(lanobj) {			
			commit("setLanguageChange",{prefix:prefix,key:arg.key,full:key,code:arg.code})
			return new Promise((res)=>{res(lanobj)});
		}
		return axios.get(api.ajaxgetlang).then((data)=>{
			if(data && data.code == 200){
				commit("setLanguageChange",{prefix:prefix,key:arg.key,full:key,code:arg.code})
				tools.setSlocal(key,data.data);
			}
		});
	},
	changeLang({dispatch},arg){		
		return dispatch("getCommonData").then((res)=>{
			if(res){
				return dispatch("getLuanguge",{key:arg.key,code:res.top.languageActive.code});
			}			
		});
	},
	getLoginStatus({commit}) {
	//  获取登录状态
		return new Promise((resolve) => {
			axios.jsonp(window.LOGINURL + "/auth/getCrossToken").then((res)=>{ 
				if(res.retCode == 200 && res.result){
					//已登录  设置登录信息  
					commit("setLoginInfo",res.result)
					resolve(res.result)                      
				}else{
					//登录失败 清除登录信息
					commit("clearUserInfo")
					resolve(res)                     
				}
			})
		})
	
	}
}